(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('EditPlantioModalCtrl', EditPlantioModalController);

  EditPlantioModalController.$inject = [
    'plantio',
    'LoadingService',
    'AtividadesService',
    '$q',
    'ItensService',
    'MessagesService',
    '$scope',
    'PlantiosService',
    'PeriodosService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function EditPlantioModalController(plantio, LoadingService, AtividadesService,
    $q, ItensService, MessagesService,
    $scope, PlantiosService, PeriodosService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.area = +plantio.area;
    vm.dataInicio = moment(plantio.data_inicio).toDate();
    vm.dataFim = moment(plantio.data_fim).toDate();
    vm.atividade = null;
    vm.cultivar = null;
    vm.atividades = [];
    vm.cultivares = [];
    vm.periodos = [];
    vm.saving = false;
    vm.deleting = false;

    //////////////////////////////////////////
    // Bindable functions
    vm.changeAtividade = changeAtividade;
    vm.save = save;
    vm.deleteSimples = deleteSimples;
    vm.invalidDates = invalidDates;

    //////////////////////////////////////////
    // Function declarations

    function changeAtividade() {
      vm.cultivares = [];
      vm.cultivar = null;
      LoadingService.showLoading();
      return loadCultivares()
        .then(({ data }) => {
          vm.cultivares = data;
        })
        .catch(loadError)
        .finally(LoadingService.hideLoading);
    }

    function loadCultivares(atividade = vm.atividade.id) {
      return ItensService.listCultivares({
        no_paginate: true,
        only_cultivares: true,
        atividade
      });
    }

    function loadPeriodos() {
      return PeriodosService.list();
    }

    function loadError(error) {
      console.error(error);
      MessagesService.alert('Não foi possível carregar os dados necessários');
    }

    function invalidDates() {
      return vm.dataInicio > vm.dataFim;
    }

    function save() {
      vm.saving = true;

      return PlantiosService.updatePlantioSimples({
        cultivar: vm.cultivar,
        atividade: vm.atividade,
        periodo: vm.periodo,
        area: vm.area,
        dataInicio: vm.dataInicio,
        dataFim: vm.dataFim,
        plantio: plantio.id
      }).then(() => {
        MessagesService.alert('Plantio atualizado com sucesso!');
        $scope.$close(true);
      })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Não foi possível editar o plantio, tente novamente');
        })
        .finally(() => {
          vm.saving = false;
        });
    }

    function deleteSimples() {
      vm.deleting = true;

      MessagesService.confirm('Deseja realmente excluir o plantio simplificado?')
        .then(function() {
          PlantiosService.deletePlantioSimples(plantio.id).then(function() {
            MessagesService.alert('Plantio simplificado excluído com sucesso.');
            $scope.$close(true);
          })
            .catch(function(error) {
              console.error(error);
              MessagesService.alert('Não foi possível excluir o plantio, tente novamente');
            })
            .finally(() => {
              vm.deleting = false;
            });
        });
    }

    //////////////////////////////////////////
    // Controller logic

    LoadingService.showLoading();
    $q.all([
      AtividadesService.list(),
      loadCultivares(plantio.atividade_id),
      loadPeriodos()
    ])
      .then(([atividades, cultivares, periodos]) => {
        vm.atividades = atividades.data;
        vm.atividade = _.find(vm.atividades, { id: plantio.atividade_id });
        vm.cultivares = cultivares.data;
        vm.cultivar = _.find(vm.cultivares, { item_id: plantio.insumo_id });
        vm.periodos = periodos.data;
        vm.periodo = _.find(vm.periodos, { codigo: plantio.periodo_id });
      })
      .catch((error) => {
        loadError(error);
        $scope.$close();
      })
      .finally(LoadingService.hideLoading);
  }
}());
